import {
  transformEstablishment,
  transformEstablishmentList,
  transformEstablishmentRequest,
} from '@/common/integrations/menhir/employee/establishments/establishments.dto';
import {
  EstablishmentNetworkType,
  IEstablishment,
  IMenhirEstablishment,
  IMenhirEstablishmentList,
  IMenhirEstablishmentRequestEnvelope,
  INetworkEstablishmentRequest,
  TRequestEstablishmentParam,
} from '@/common/integrations/menhir/employee/establishments/establishments.types';
import { menhirClient } from '@/common/integrations/menhir/menhir.client';
import {
  MENHIR_ENDPOINTS,
  endpointFor,
} from '@/common/integrations/menhir/menhir.endpoints';

export const getEstablishments = (
  ...establishmentTypeFilters: EstablishmentNetworkType[]
): Promise<IEstablishment[]> =>
  menhirClient
    .get<null, IMenhirEstablishmentList>(
      MENHIR_ENDPOINTS.EMPLOYEE.ESTABLISHMENTS.ROOT,
      {
        params: {
          'filters[type_slug]': establishmentTypeFilters.length
            ? establishmentTypeFilters.join(',')
            : undefined,
          pagination: 'no',
        },
      }
    )
    .then((envelope) => transformEstablishmentList(envelope.establishments));

export const requestEstablishment = ({
  name,
  email,
  typeSlug,
  phoneCode,
  phoneNumber,
  contactName,
  location,
  familyMemberName,
}: TRequestEstablishmentParam) =>
  menhirClient
    .post<null, IMenhirEstablishmentRequestEnvelope>(
      MENHIR_ENDPOINTS.EMPLOYEE.ESTABLISHMENTS.REQUEST,
      {
        establishment_request: {
          email,
          name,
          phone:
            !!phoneCode && !!phoneNumber
              ? {
                  country_code: phoneCode,
                  number: phoneNumber,
                }
              : undefined,
          contact_name: contactName ? contactName : undefined,
          establishment_type_slug: typeSlug,
          location_description: location,
          family_member_name: familyMemberName,
        },
      }
    )
    .then((envelope) =>
      transformEstablishmentRequest(envelope.establishment_request)
    );

export const getEstablishment = (id: string) =>
  menhirClient
    .get<
      null,
      IMenhirEstablishment
    >(endpointFor(MENHIR_ENDPOINTS.EMPLOYEE.ESTABLISHMENTS.DETAIL, id))
    .then(transformEstablishment);

export const requestNetworkEstablishment = (
  request: INetworkEstablishmentRequest
) =>
  menhirClient.post<null, IMenhirEstablishmentRequestEnvelope>(
    MENHIR_ENDPOINTS.EMPLOYEE.NETWORKS.REQUEST,
    request
  );
